import { render, staticRenderFns } from "./ArticleQuickCreateModal.vue?vue&type=template&id=7357c336&"
import script from "./ArticleQuickCreateModal.vue?vue&type=script&lang=js&"
export * from "./ArticleQuickCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports